import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Megaphone, MapPin, MessageCircle } from "lucide-react";

export default function PromoBanner() {
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    api.get("/promo").then((r) => setPromo(r.data)).catch(() => {});
  }, []);

  if (!promo?.enabled || !promo.message) return null;

  const now = new Date();
  const winterEnd = new Date("2027-03-19T23:59:59-04:00");
  let promoText = promo.message;
  if (now <= winterEnd) {
    promoText = "❄️ Winter Special — 10% off all rentals with code WINTER10 · book early and save";
  }

  const messages = [
    { icon: Megaphone, text: promoText },
    { icon: MapPin, text: "Free hotel & villa delivery — anywhere on New Providence & Paradise Island" },
    { icon: MessageCircle, text: "WhatsApp +1 (242) 813-1775 — we reply in minutes" },
  ];
  const loop = [...messages, ...messages, ...messages];

  return (
    <div data-testid="promo-banner" className="no-print fixed top-[5.125rem] inset-x-0 z-40 bg-primary text-primary-foreground overflow-hidden py-1.5 shadow-[0_2px_12px_rgba(199,30,46,0.35)]">
      <div className="marquee flex w-max items-center justify-center whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {loop.map((m, i) => (
              <span key={i} data-testid={i < 3 ? `promo-banner-message-${i}` : undefined} className="flex items-center justify-center gap-2 px-10 text-center font-display font-bold text-xs sm:text-sm tracking-[0.06em]">
                <m.icon size={13} className="shrink-0" />
                {m.text}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
